import { parseJson } from '../../helpers/titreHelper';

export const useGetDescriptionParams = (advancedSettings) => {
  if (!advancedSettings) {
    return {};
  }

  const parsedAdvanced = parseJson(advancedSettings);

  if (typeof parsedAdvanced !== 'object') {
    return {};
  }

  const link = parsedAdvanced?.titresSettings?.titres?.[0]?.firstLink;

  if (!link) {
    return {};
  }
  const searchParams = new URLSearchParams(new URL(link).search);

  return {
    fio: searchParams.get('ФИО'),
    position: searchParams.get('Должность'),
    report: searchParams.get('Доклад'),
    thema: searchParams.get('Тема') || '20',
  };
};
